<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [isPanelOpened]="isPanelOpened"
         [accordionHeading]="tablesTranslations.i18nRequestedTicketsPerCategory"
         [spinnerName]="spinnerName"
         [emptyStateIcon]="'#esf-icon-dollar-check'"
         [emptyStateText]="tablesTranslations.i18nNoPriceCategories"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened);"
         [data]="categories"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>
